//接口加密
import { interfaceCryptoInit } from '@x7web/crypto'
import { OpenPlatformCurrentModeConst } from '@/constant'

const { VITE_OPEN_PLATFORM_CURRENT_MODE } = import.meta.env

const key = VITE_OPEN_PLATFORM_CURRENT_MODE === OpenPlatformCurrentModeConst.Production ? 4 : 1

const interfaceCryptoInstance = interfaceCryptoInit(key)

/** 参数加密 */
const encryptRequestParams = interfaceCryptoInstance[1]
/** 响应结果解密 */
const resDecode = interfaceCryptoInstance[2]
/** 接口匿名化 */
const apiReName = interfaceCryptoInstance[3]

/** 接口数据加密 */
function encrypt(data?: any, time?: number) {
  if (
    !data ||
    typeof data !== 'object' ||
    (typeof data.c === 'string' && typeof data.t === 'number') //判断已加密数据
  )
    return data
  const realTime = time || Date.now() + Number(sessionStorage.getItem('realTimeGap') || 0)
  return encryptRequestParams(data, realTime)
}

export { encryptRequestParams, resDecode, apiReName, encrypt }
